import Vue from 'vue'
import router from './router'
import store from '@district/store'
import App from '@district/App'
import routerConfig from '../comm/router/config'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import api from '../comm/http/index'
// import '@comm/assets/css/font.css'
import i18n from '../i18n/i18n'

Vue.config.productionTip = false
Vue.use(api)
Vue.use(Antd)
routerConfig(router)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  template: '<App/>',
  components: { App },
  beforeCreate (){                 //在初始化阶段前
    Vue.prototype.$bus = this   //配置全局总线，bus有总线的意思
  }
})



// WEBPACK FOOTER //
// ./src/district/main.js